/**
 * The message fields an AI snippet or a variables-panel insert writes into the selected step: an
 * invite step keeps a premium and a standard note, every other step one message; an event-based
 * campaign writes the alternate copy.
 */
export const selectedNodeMessageUpdates = (
	nodeType: string | undefined,
	eventBased: boolean,
	results: string[]
): Record<string, string | undefined> => {
	if (nodeType === "linkedinInviteNode") {
		return eventBased
			? { alternatePremiumMessage: results[0], alternateMessage: results[1] }
			: { premiumMessage: results[0], message: results[1] };
	}

	return eventBased ? { alternateMessage: results?.[0] } : { message: results?.[0] };
};

/**
 * What the builder does when the autosave replaced the canvas from the server (a structure-lock
 * refusal, a stale-revision adoption): the graph re-renders, and the open step panel closes, since
 * the step it shows may be one the server refused. Left open, its typing was thrown away while
 * the chip read "Saved" (PREC-4616 QA, I8).
 */
export const canvasReplacedHandler =
	(bumpGraph: () => void, closeStepPanel: () => void): (() => void) =>
	() => {
		bumpGraph();
		closeStepPanel();
	};
